// extracted by mini-css-extract-plugin
export default {"sample_btn":"bulkUpload_sample_btn__b6HM8","errors":"bulkUpload_errors__WnJaf","error_list":"bulkUpload_error_list__VQhYg","field":"bulkUpload_field__8NyrJ"};